var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascotte11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#F4EFFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480.606 63.1739C544.511 59.902 564.912 104.122 665.725 85.7497C746.112 71.1018 780.719 125.792 790.73 159.769C795.507 176.002 796.721 239.451 752.609 240.357C602.906 243.478 482.957 407.926 410.785 264.116C381.512 205.776 335.529 70.6236 480.606 63.1739Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M-141.394 -87.8261C-77.4885 -91.098 -57.0883 -46.8776 43.7247 -65.2503C124.112 -79.8982 158.719 -25.2079 168.73 8.76903C173.507 25.0025 174.721 88.4512 130.609 89.3573C-19.0939 92.4781 -139.043 256.926 -211.215 113.116C-240.488 54.7763 -286.471 -80.3764 -141.394 -87.8261Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 37,
    width: 370,
    height: 140,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.359 331.714C241.166 360.505 266.881 392.719 298.859 392.935C330.85 393.151 356.999 361.298 357.191 332.494C357.384 303.702 331.56 288.862 299.57 288.646C267.58 288.43 241.551 302.91 241.347 331.702L241.359 331.714Z",
    fill: "url(#paint0_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.317 303.11L337.306 303.116C331.294 306.105 328.851 313.387 331.85 319.38L349.086 353.826C352.085 359.819 359.389 362.254 365.402 359.265L365.412 359.259C371.424 356.27 373.867 348.988 370.868 342.995L353.632 308.549C350.634 302.556 343.329 300.121 337.317 303.11Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.123 218.744L244.816 207.025C238.914 203.436 231.495 203.412 225.569 206.965C215.572 212.945 208.044 222.298 204.358 233.32C198.24 251.606 206.43 271.597 223.63 280.386L242.756 290.159L264.123 218.732V218.744Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.51 229.586L244.455 219.849C239.54 216.871 233.374 216.847 228.447 219.801C220.137 224.772 213.873 232.552 210.814 241.713C205.731 256.913 212.537 273.53 226.845 280.842L242.744 288.971L260.51 229.586Z",
    fill: "url(#paint2_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.205 265.317C238.359 264.344 244.093 271.116 241.286 278.98L239.684 283.447C238.179 287.661 235.143 296.462 238.685 299.212L249.934 309.513C261.907 324.617 252.367 334.931 248.14 335.724C234.601 338.245 216.667 309.801 216.667 309.801C211.223 301.097 214.872 293.136 216.872 286.989C219.751 278.14 225.147 266.145 231.205 265.329V265.317Z",
    fill: "url(#paint3_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.224 218.744L350.531 207.025C356.433 203.436 363.852 203.412 369.778 206.965C379.775 212.945 387.303 222.298 390.989 233.32C397.107 251.606 388.917 271.597 371.717 280.386L352.591 290.159L331.224 218.732V218.744Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.837 229.585L350.892 219.848C355.806 216.87 361.973 216.846 366.9 219.8C375.21 224.771 381.473 232.551 384.533 241.712C389.616 256.912 382.81 273.529 368.501 280.841L352.603 288.97L334.837 229.585Z",
    fill: "url(#paint4_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.105 275.499C362.105 310.979 333.259 326.887 297.667 326.887C262.075 326.887 233.229 310.979 233.229 275.499C233.229 240.02 272.951 201.923 297.667 201.923C322.382 201.923 362.105 240.02 362.105 275.499Z",
    fill: "url(#paint5_linear_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.96 206.509C289.645 210.855 289.742 223.51 289.742 223.51C289.874 223.942 290.488 223.798 290.693 223.666C291.572 223.102 293.596 220.641 293.596 220.641C293.849 220.28 294.391 220.364 294.535 220.773C294.535 220.773 295.872 225.359 296.173 229.477C296.197 229.742 296.992 229.598 297.197 229.453C299.112 228.073 300.726 220.497 300.726 220.497C300.847 220.076 301.377 219.968 301.654 220.292C301.654 220.292 303.822 221.277 304.954 224.231C305.038 224.459 305.713 224.159 305.893 223.99C309.495 220.701 311.687 208.238 308.989 204.36C305.159 198.849 278.685 202.463 283.96 206.497V206.509Z",
    fill: "#8058EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.165 284.78C334.476 284.78 342.834 274.029 342.834 260.767C342.834 247.505 334.476 236.754 324.165 236.754C313.855 236.754 305.496 247.505 305.496 260.767C305.496 274.029 313.855 284.78 324.165 284.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.922 261.295C290.922 274.562 282.563 285.308 272.253 285.308C261.943 285.308 253.584 274.562 253.584 261.295C253.584 256.588 256.113 251.149 256.113 251.149H288.634C288.634 251.149 290.922 256.853 290.922 261.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.407 264.345C281.407 259.703 277.633 255.94 272.976 255.94C268.32 255.94 264.545 259.703 264.545 264.345V269.172C264.545 273.813 268.32 277.576 272.976 277.576C277.633 277.576 281.407 273.813 281.407 269.172V264.345Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.892 268.043C274.221 268.043 276.108 266.162 276.108 263.841C276.108 261.52 274.221 259.639 271.892 259.639C269.564 259.639 267.677 261.52 267.677 263.841C267.677 266.162 269.564 268.043 271.892 268.043Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.476 264.225C332.476 259.583 328.701 255.82 324.044 255.82C319.388 255.82 315.613 259.583 315.613 264.225V269.052C315.613 273.693 319.388 277.456 324.044 277.456C328.701 277.456 332.476 273.693 332.476 269.052V264.225Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.479 268.043C324.807 268.043 326.695 266.162 326.695 263.841C326.695 261.52 324.807 259.639 322.479 259.639C320.151 259.639 318.264 261.52 318.264 263.841C318.264 266.162 320.151 268.043 322.479 268.043Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.271 294.818C261.907 294.782 269.242 299.572 271.796 303.895",
    stroke: "#806CFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.542 345.521L273.12 342.808C272.048 340.755 272.916 338.089 275.108 337.321C275.264 337.273 283.178 338.101 286.454 337.009C290.067 335.808 293.681 331.005 292.476 323.801C290.874 314.256 282.624 307.617 281.829 301.289C280.432 290.183 287.176 282.511 296.186 280.158C305.195 277.804 315.361 282.979 319.107 291.54C322.84 300.076 320.709 319.803 317.77 328.604C314.156 339.41 303.822 345.581 298.065 347.478C288.887 350.504 278.553 349.628 278.553 349.628C275.614 350.216 274.578 347.743 274.542 345.533V345.521Z",
    fill: "url(#paint6_linear_0_1)"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261 202L234 177H256.909L261 202Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 78,
    y: 22,
    width: 430,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 233.347,
    y: 283.644,
    width: 131.846,
    height: 120.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 201.81,
    y: 255.224,
    width: 61.9424,
    height: 90.6582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0 0 0 0 0 0.447059 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 225.229,
    y: 196.923,
    width: 144.877,
    height: 140.965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_1",
    x: 281.268,
    y: 200.549,
    width: 30.9238,
    height: 32.0762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_0_1",
    x: 264.662,
    y: 274.589,
    width: 64.4375,
    height: 86.1562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 299.283,
    y1: 288.658,
    x2: 299.281,
    y2: 392.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 342.55,
    y1: 301.347,
    x2: 340.389,
    y2: 359.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 260.51,
    y1: 253.287,
    x2: 209.14,
    y2: 253.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 231.921,
    y1: 334.142,
    x2: 240.576,
    y2: 266.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 334.837,
    y1: 253.286,
    x2: 386.195,
    y2: 253.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 297.667,
    y1: 326.887,
    x2: 297.667,
    y2: 201.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 296.872,
    y1: 279.581,
    x2: 296.872,
    y2: 349.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 226,
    fill: "white",
    transform: "translate(193 190)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotte11);
export default __webpack_public_path__ + "static/media/mascotte11.f15c9238ce3eab18af629d8f970940d5.svg";
export { ForwardRef as ReactComponent };